/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import avatar from 'flarum/common/helpers/avatar';
import app from 'flarum/forum/app';
import { slug } from '../../../common';
import UnlockedBy from './UnlockedBy';

// Make translation calls shorter
const t = (...args) => app.translator.trans(...args);
const prfx = `${slug}.forum.achievement`;

export default class AchievementLevelUsers extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		const { achievementLevel } = this.attrs;

		const canViewAchievementUsers = app.forum.attribute('canViewAchievementUsers');

		const userCount = achievementLevel.userCount();
		const additionalUsersCount = achievementLevel.userCount() - achievementLevel.lastUsers().length;

		return (
			<div className="AchievementLevelUsers">
				{!!userCount ? (
					[
						<div className="AchievementLevelUsers-header">
							<UnlockedBy achievementLevel={achievementLevel} />
						</div>,

						canViewAchievementUsers && [
							<div className="AchievementLevelUsers-list">{achievementLevel.lastUsers().map((user) => avatar(user))}</div>,
							!!additionalUsersCount && (
								<div className="AchievementLevelUsers-footer">
									{t(`${prfx}.show_all`, {
										count: additionalUsersCount,
									})}
								</div>
							),
						],
					]
				) : (
					<div className="AchievementLevelUsers-placeholder">{t(`${prfx}.be_the_first`)}</div>
				)}
			</div>
		);
	}
}
